import * as yup from 'yup';

import i18n from 'Utilities/i18n';

export const BLANK_ERROR = 'BLANK_ERROR';

yup.addMethod(yup.string, 'limitChar', function(
  regex = /[^\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Connector_Punctuation}\p{Join_Control}\p{White_Space}`~!@#&$%^*()_+-={}|[\]\\;:'"<>?,./]/u,
  errorMessage
) {
  let errMessage;

  return this.test({
    message: errMessage,
    params: { regex, errorMessage },
    test: function(value) {
      const { path, createError } = this;

      if (!value) {
        return true;
      }

      const invalidInfo = value.match(regex);

      if (invalidInfo !== null) {
        const invalidChars = invalidInfo[0];

        errMessage = errorMessage || i18n.t('Errors.genericInvalidChar', { char: invalidChars });

        return createError({ path: path, message: errMessage });
      } else {
        return true;
      }
    },
  });
});

yup.string().limitChar();

export * from 'yup';
export const string = yup.string; // Override the string constructor with the one we made above
